import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'
import type { VariantProps } from 'class-variance-authority'
import { tw } from 'utils/classnames'

const buttonVariants = cva(
  'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-2 transition-colors disabled:pointer-events-none [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 box-content',
  {
    variants: {
      variant: {
        purple: 'text-cf-white bg-[#403068] hover:bg-[#2A2045] border boder-[#403068]',
        green: 'text-cf-white bg-[#0F7B59] hover:bg-[#0B5A41] border border-[#0F7B59]',
        outline: 'text-cf-grey-1000 bg-cf-white border border-cf-grey-600 hover:bg-cf-grey-50',
        pagination:
          'rounded-full bg-cf-dreamy-cloud-400 hover:shadow-[0px_2px_2px_0px_#00000050] disabled:bg-cf-dreamy-cloud-200 disabled:text-cf-dreamy-cloud-600 text-black',
        'pagination-main':
          'rounded-full bg-[#8A67CA] text-cf-white hover:shadow-[0px_2px_2px_0px_#00000050] disabled:bg-[#A697C1]',
      },
      size: {
        default: 'text-14 py-2 px-3 leading-4 font-medium',
        micro: 'text-12 py-1 px-2 leading-2 font-semibold',
        pagination: 'h-10 w-10 font-medium',
      },
    },
    defaultVariants: {
      variant: 'purple',
      size: 'default',
    },
  },
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>, VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = ({
  ref,
  className,
  variant,
  size,
  asChild = false,
  ...props
}: ButtonProps & {
  ref?: React.RefObject<HTMLButtonElement>
}) => {
  const Comp = asChild ? Slot : 'button'
  return <Comp className={tw(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
}
Button.displayName = 'Button'

export { Button, buttonVariants }
